import { withKeycloak } from "@react-keycloak/web";
import React from "react";
import ClassificationService from "../../../../services/ClassificationService";
import { activeFilterPageInfo } from "../../../../services/FilteringUtils";
import PageComponent from "../PageComponent";
import ClassificationSelection from "./ClassificationSelection";

class ClassificationSelectionContainer extends PageComponent {
  constructor(props) {
    super(props);

    this.classificationService = new ClassificationService(this.keycloak);

    this.state = {
      selectedClassifications: undefined,
      reset: false,
      isLoading: false
    };

    this.setSelectedClassifications = this.setSelectedClassifications.bind(
      this
    );
  }

  componentDidUpdate() {
    if (!this.state.isLoading) {
      if (this.props.entity?.id) {
        if (!("classifications" in this.props.entity)) {
          this.loadEntityClassifications();
        }
      } else if (
        this.props.classifications !== this.state.defaultClassifications
      ) {
        const reset =
          this.state.defaultClassifications && !this.props.classifications;
        this.setState({
          defaultClassifications: this.props.classifications,
          reset
        });
      }
    }
  }

  loadEntityClassifications = () => {
    this.setState({ isLoading: true });
    const url = this.props.entity._links.classifications.href;
    this.prepareCall(
      this.classificationService.getEntitiesWithParams(
        url,
        activeFilterPageInfo,
        undefined,
        this.onClassificationsLoad,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  onClassificationsLoad = data => {
    const classifications = data._embedded
      ? data._embedded.content.map(item => {
          return { id: item.id };
        })
      : [];
    this.props.setInitialEntityPropertyState("classifications", [
      ...classifications
    ]);
    this.setState({
      isLoading: false,
      defaultClassifications: classifications
    });
  };

  reseted = () => {
    this.setState({ reset: false });
  };

  setSelectedClassifications = selectedClassifications => {
    this.setState({ selectedClassifications });
    if (this.props.setClassificationsOnEntity) {
      const classifications = selectedClassifications.map(key => {
        return { id: parseInt(key) };
      });
      this.props.setClassificationsOnEntity(classifications);
    }
  };

  render() {
    return (
      <ClassificationSelection
        {...this.props}
        selectedClassifications={this.state.selectedClassifications}
        setSelectedClassifications={this.setSelectedClassifications}
        defaultClassifications={this.state.defaultClassifications}
        reset={this.state.reset}
        reseted={this.reseted}
      />
    );
  }
}

export default withKeycloak(ClassificationSelectionContainer);
